<template>
	
	<div class="page-list main-container">
		<h1 class="title">Page List</h1>
		<p class="search" ref="search">
			<input type="search" @search="gotSearchEvent" placeholder="Search Pages" v-model="searchQuery" v-focus incremental />
		</p>
		<p v-if="!loggedIn" id="page-list-login-prompt">
			<a href="#" @click.prevent="clickedLogin">Log in</a> to see more pages.
		</p>

		<ul v-if="pages && pages.length">
			<li v-for="page in pages" :key="page.guid">
				<router-link :to="linkForPage(page)">
					{{ page.title || '(untitled)' }}
					<span v-if="page.private" class="private">lock</span>
					<span v-if="page.isDeleted" class="deleted">delete_outline</span>
				</router-link>
			</li>
		</ul>
		<p v-else-if="pages && searchQuery && pages.length < 1">No pages found.</p>
		<p v-else class="loading">Loading page list…</p>

		<login-popover ref="loginPopover" reason="Log in to see more content." />
	</div>

</template>


<script>

	import PagesService from '@/services/PagesService'
	import LinkForPage from '@/mixins/link-for-page'
	import LoginPopover from '@/components/LoginPopover.vue'
	
	export default {
		name: 'page-list',
		mixins: [LinkForPage],
		components: { LoginPopover },
		data() {
			return {
				pages: [],
				searchQuery: ''
			}
		},
		computed: {
			loggedIn() {
				return this.$store.getters.isLoggedIn
			}
		},
		watch: {
			loggedIn() {
				this.getPages()
			}
		},
		mounted() {
			document.title = 'All Pages'
			this.getPages()
		},
		methods: {
			async getPages() {
				const pagesResponse = await PagesService.getPages(this.searchQuery)
				this.pages = pagesResponse.data
			},
			async gotSearchEvent() {
				await this.getPages()
			},
			clickedLogin() {
				this.$refs.loginPopover.showFromElement('page-list-login-prompt')
			}
		}
	}

</script>


<style lang="scss">

	.page-list {

		padding-bottom: 120px;
		text-align: center;

		.search {
			text-align: center;
			margin-top: 0px;
			margin-bottom: 30px;
			
			& > input {
				width: 300px;
				padding: 4px;
				font-size: 16px;
				appearance: none;
				opacity: 0.5;
				transition: opacity 0.5s;
				border: 1px solid $page-border-color;

				&:focus {
					opacity: 1.0;
				}
			}
		}

		.loading {
			margin-top: 5vh;
			text-align: center;
		}

		#page-list-login-prompt {
			font-style: italic;
			font-size: 14px;
			line-height: 14px;
			margin-top: -20px;
			margin-bottom: 20px;
		}

		ul {
			columns: 2;
			list-style-type: none;
			padding-left: 80px;
			padding-right: 40px;

			li {
				text-align: left;
				margin-bottom: 4px;
			}

			@include mobile {
				columns: 1;
			}
		}

		.private, .deleted {
			position: relative;
			top: 1px;
			left: -1px;
			font-family: 'Material Icons';
			font-size: 12px;
		}

	}
	
</style>
